import {mutations} from '@/store/modules/Category/mutations';
import {state} from '@/store/modules/Category/state';
import {getters} from '@/store/modules/Category/getters';
import {actions} from '@/store/modules/Category/actions';

export default {
  state,
  getters,
  actions,
  mutations,
}
